import React from "react";

export default class BaseRow extends React.Component {
	generateHigherSvg() {
		return <span className="icon24 icon-arrow-2-up" />;
	}

	generateBelowSvg() {
		return <span className="icon24 icon-arrow-2-down" />;
	}
}
